"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModificationsLookupWidget = void 0;
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var journey_services_1 = require("@athena-portal/journey-services");
var React = require("react");
var ModificationsLookupWidget = exports.ModificationsLookupWidget = /** @class */ (function (_super) {
    __extends(ModificationsLookupWidget, _super);
    function ModificationsLookupWidget(props) {
        var _this = _super.call(this, props) || this;
        var interactionVehicleSetting = _this.getSetting("interactionVehicle", undefined);
        if (interactionVehicleSetting) {
            _this.interactionVehicle = journey_services_1.ObjectManipulator.fetchFieldValue(interactionVehicleSetting, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicle' setting"));
        }
        _this.lookupService.fetchLookupValues("vehicleModification", "en-UK").subscribe(function (lookupValues) {
            var modifications = _this.interactionVehicle.modifications;
            lookupValues = lookupValues.filter(function (item) { return modifications === null || modifications === void 0 ? void 0 : modifications.includes(item.id); });
            _this.state = {
                selectedModification: { id: "", value: "" },
                modifications: lookupValues ? lookupValues : [],
                lookedUpModifications: [],
                modifcationValid: null,
                modificationFound: "",
                typingTimeout: 0,
                modificationLoading: false
            };
        });
        _this.addSelectedModification = _this.addSelectedModification.bind(_this);
        _this.isModificationLoading = _this.isModificationLoading.bind(_this);
        _this.isModificationValid = _this.isModificationValid.bind(_this);
        _this.handleModificationChange = _this.handleModificationChange.bind(_this);
        _this.renderFoundModifications = _this.renderFoundModifications.bind(_this);
        _this.findModifications = _this.findModifications.bind(_this);
        _this.onSelectModification = _this.onSelectModification.bind(_this);
        _this.onKeyPressModification = _this.onKeyPressModification.bind(_this);
        _this.removeSelectedModification = _this.removeSelectedModification.bind(_this);
        return _this;
    }
    ModificationsLookupWidget.prototype.renderInputField = function () {
    };
    ModificationsLookupWidget.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: "modification-lookup" },
            this.renderModificationList(),
            React.createElement("div", null,
                React.createElement("div", { className: "font-weight-light mb-3" }, "Start typing the first 3 letters of the changes that have been applied to the car..."),
                React.createElement("input", { type: "text", className: "form-control ".concat(this.isModificationLoading(), " ").concat(this.isModificationValid()), id: "modifications-lookup", "aria-describedby": "makeDescription", value: (_a = this.state.selectedModification) === null || _a === void 0 ? void 0 : _a.value, onChange: this.handleModificationChange, autoComplete: "off" }),
                React.createElement("div", { id: "makeDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.lookedUpModifications) }),
                this.renderFoundModifications(),
                this.state.modifcationValid === 'is-invalid' && React.createElement("div", { className: "invalid-feedback d-block" }, "Modifications are mandatory."),
                this.state.modifcationValid === 'is-invalid' && React.createElement("div", { className: "invalid-feedback d-block" }, "Modification not found. Please refine your criteria"),
                this.state.modifcationValid === 'already-exists' && React.createElement("div", { className: "invalid-feedback d-block" }, "This modification is already in the list")),
            React.createElement("button", { className: "btn btn-back ml-auto", id: "addSelectedModification", type: "button", onClick: this.addSelectedModification }, "Add")));
    };
    ModificationsLookupWidget.prototype.addSelectedModification = function () {
        if (this.state.selectedModification.id != "TMP" && !this.state.modifications.includes(this.state.selectedModification)) {
            var modifications = this.state.modifications.concat(this.state.selectedModification);
            this.setState({
                modifications: modifications,
                selectedModification: { id: "", value: "" },
                lookedUpModifications: [],
                modifcationValid: "",
                modificationFound: ""
            });
            this.interactionVehicle.modifications = modifications.map(function (item) { return item.id; });
            this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
            this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
        }
        else if (this.state.modifications.includes(this.state.selectedModification)) {
            this.setState({ modifcationValid: "already-exists" });
        }
    };
    ModificationsLookupWidget.prototype.removeSelectedModification = function (event) {
        var modifications = this.state.modifications.filter(function (value) { return value.id != event.target.dataset.id; });
        this.setState({
            modifications: modifications
        });
        this.interactionVehicle.modifications = modifications;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicle), this.interactionVehicle);
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicle, this.props.page && this.props.page.pageId);
    };
    ModificationsLookupWidget.prototype.renderModificationList = function () {
        var _this = this;
        var modificationsList = [];
        if (this.state.modifications.length > 0) {
            this.state.modifications.forEach(function (modification) {
                modificationsList.push(React.createElement("div", { className: "modifications-item my-1" },
                    React.createElement("div", { className: "modifications-item-text" }, modification.value),
                    React.createElement("img", { className: "modifications-item-image", onClick: _this.removeSelectedModification, "data-id": modification.id, src: "/img/cross.svg" })));
            });
            return (React.createElement("div", { className: "mb-3 modifications-list" }, modificationsList));
        }
        else {
            return null;
        }
    };
    ModificationsLookupWidget.prototype.isModificationLoading = function () {
        if (this.state.modificationLoading) {
            return 'loading-input';
        }
        return '';
    };
    ModificationsLookupWidget.prototype.isModificationValid = function () {
        if (this.state.modifcationValid === 'is-valid' && this.state.modificationFound === 'is-valid') {
            return 'is-valid';
        }
        else if (this.state.modifcationValid === 'is-invalid' || this.state.modificationFound === 'is-invalid') {
            return 'is-invalid';
        }
        return "";
    };
    ModificationsLookupWidget.prototype.handleModificationChange = function (event) {
        var _this = this;
        var _a;
        var selectedModificationValue = (event.target.validity.valid) ? event.target.value : (_a = this.state.selectedModification) === null || _a === void 0 ? void 0 : _a.value;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            selectedModification: { id: "TMP", value: selectedModificationValue },
            typingTimeout: setTimeout(function () {
                _this.findModifications();
            }, 300),
            modifcationValid: selectedModificationValue.length > 0 ? 'is-valid' : 'is-invalid',
        });
    };
    ModificationsLookupWidget.prototype.renderFoundModifications = function () {
        var _this = this;
        var modificationsList = [];
        var filteredList = [];
        if (this.state.lookedUpModifications && this.state.lookedUpModifications.length > 0) {
            filteredList = this.state.lookedUpModifications.filter(function (modification) { var _a; return modification === null || modification === void 0 ? void 0 : modification.value.toLowerCase().includes((_a = _this.state.selectedModification) === null || _a === void 0 ? void 0 : _a.value.toLowerCase()); });
            filteredList.forEach(function (modification) {
                modificationsList.push(React.createElement("li", { onClick: _this.onSelectModification, onKeyDown: _this.onKeyPressModification, key: modification.id, "data-id": modification.id, tabIndex: 0 }, modification === null || modification === void 0 ? void 0 : modification.value));
            });
            return (React.createElement("div", { className: "addressLookupWrapper" },
                React.createElement("ul", { className: "addressesFound" }, modificationsList)));
        }
        else {
            return null;
        }
    };
    ModificationsLookupWidget.prototype.findModifications = function () {
        var _this = this;
        this.lookupService.fetchLookupValues("vehicleModification", "en-UK").subscribe(function (lookupValues) {
            _this.setState({
                lookedUpModifications: lookupValues,
            });
        });
    };
    ModificationsLookupWidget.prototype.onSelectModification = function (event) {
        var selectedModification = this.state.lookedUpModifications.filter(function (modification) { return modification.id == event.target.dataset.id; })[0];
        this.setState({
            selectedModification: selectedModification,
            lookedUpModifications: []
        });
    };
    ModificationsLookupWidget.prototype.onKeyPressModification = function (event) {
        var activeEl = document.activeElement;
        if (event.key === "Enter") {
            this.onSelectModification(event);
        }
        else if (event.key === "ArrowDown" && activeEl && activeEl.nextElementSibling && activeEl.nextElementSibling instanceof HTMLElement) {
            activeEl.nextElementSibling.focus();
        }
        else if (event.key === "ArrowUp" && activeEl && activeEl.previousElementSibling && activeEl.previousElementSibling instanceof HTMLElement) {
            activeEl.previousElementSibling.focus();
        }
    };
    ModificationsLookupWidget.prototype.ariaSuggestionsAvailableString = function (array) {
        var defaultSTR = "Suggestion size ";
        if (array && array.length > 0) {
            return defaultSTR + array.length;
        }
        else {
            return '';
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], ModificationsLookupWidget.prototype, "lookupService", void 0);
    return ModificationsLookupWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=ModificationsLookupWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/ModificationsLookupWidget.js
// module id = 3157
// module chunks = 0